module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"svg":{"alia-label":{"search":"絞り込み検索のアイコン","sort":"並び替えのアイコン"},"title":{"search":"絞り込み検索","sort":"並び替え"},"desc":{"search":"絞り込み検索","sort":"並び替え"}}}}')
  delete Component.options._Ctor
}
